<ng-container *transloco="let t">
  <ld-base-modal
    [title]="t('modalsEconsentDisclosureDialogTitle')"
    [size]="'large'"
    [showCloseButton]="false"
    [closeOnBackdropClick]="false"
    [ariaLabelledBy]="'econsent-disclosure-modal-title'"
  >
    <div modal-content>
      <h3 id="econsent-disclosure-modal-title" class="font-dm text-lg font-bold text-ld-primary mb-2">
        {{ t('modalsEconsentDisclosureTitle') }}
      </h3>
      <p id="econsent-disclosure-description" class="font-dm text-sm text-ld-neutral-500 mb-6">
        {{ t('modalsEconsentDisclosureDescription') }}
      </p>

      <hr class="border-ld-border mb-6" />

      <div id="econsent-disclosure-content" class="max-h-[400px] overflow-y-auto pr-2 space-y-6">
        <section id="econsent-disclosure-rights">
          <h4 class="font-dm text-sm font-bold text-ld-neutral uppercase tracking-wide mb-2">
            {{ t('modalsEconsentDisclosureYourRights') }}
          </h4>
          <p class="font-dm text-sm text-ld-neutral leading-relaxed">
            {{ t('modalsEconsentDisclosureYourRightsTextPart1') }}
            <a
              id="econsent-disclosure-rights-phone"
              [href]="supportPhoneTel"
              class="text-ld-primary font-semibold underline hover:text-ld-primary-600"
            >
              {{ supportPhoneDisplay }}
            </a>
            {{ t('modalsEconsentDisclosureYourRightsTextPart2') }}
            <a
              id="econsent-disclosure-rights-email"
              [href]="customerCareEmailMailto"
              class="text-ld-primary font-semibold underline hover:text-ld-primary-600"
            >
              {{ customerCareEmail }}
            </a>
            .
          </p>
        </section>

        <section id="econsent-disclosure-where-applies">
          <h4 class="font-dm text-sm font-bold text-ld-neutral uppercase tracking-wide mb-2">
            {{ t('modalsEconsentDisclosureWhereApplies') }}
          </h4>
          <p class="font-dm text-sm text-ld-neutral leading-relaxed">
            {{ t('modalsEconsentDisclosureWhereAppliesText') }}
          </p>
        </section>

        <section id="econsent-disclosure-hardware">
          <h4 class="font-dm text-sm font-bold text-ld-neutral uppercase tracking-wide mb-2">
            {{ t('modalsEconsentDisclosureHardwareTitle') }}
          </h4>
          <p class="font-dm text-sm text-ld-neutral leading-relaxed mb-3">
            {{ t('modalsEconsentDisclosureHardwareIntro') }}
          </p>
          <ul class="list-disc pl-5 font-dm text-sm text-ld-neutral space-y-1 mb-4">
            <li>{{ t('modalsEconsentDisclosureHardwareReq1') }}</li>
            <li>{{ t('modalsEconsentDisclosureHardwareReq2') }}</li>
            <li>{{ t('modalsEconsentDisclosureHardwareReq3') }}</li>
            <li>{{ t('modalsEconsentDisclosureHardwareReq4') }}</li>
            <li>{{ t('modalsEconsentDisclosureHardwareReq5') }}</li>
          </ul>

          <div class="overflow-x-auto">
            <table id="econsent-disclosure-browser-table" class="w-full border border-ld-border text-sm font-dm">
              <thead>
                <tr class="bg-ld-neutral-50">
                  <th class="border border-ld-border px-3 py-2 text-left font-semibold text-ld-neutral">
                    {{ t('modalsEconsentDisclosureBrowserPC') }}
                  </th>
                  <th class="border border-ld-border px-3 py-2 text-left font-semibold text-ld-neutral">
                    {{ t('modalsEconsentDisclosureBrowserMac') }}
                  </th>
                  <th class="border border-ld-border px-3 py-2 text-left font-semibold text-ld-neutral">
                    {{ t('modalsEconsentDisclosureBrowserIOS') }}
                  </th>
                  <th class="border border-ld-border px-3 py-2 text-left font-semibold text-ld-neutral">
                    {{ t('modalsEconsentDisclosureBrowserAndroid') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral">Chrome</td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral">Chrome</td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral">Chrome</td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral">Chrome</td>
                </tr>
                <tr>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral">Microsoft Edge</td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral">Safari</td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral">Safari</td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral"></td>
                </tr>
                <tr>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral">Firefox</td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral">Firefox</td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral"></td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral"></td>
                </tr>
                <tr>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral">Internet Explorer 11</td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral"></td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral"></td>
                  <td class="border border-ld-border px-3 py-2 text-ld-neutral"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section id="econsent-disclosure-consenting">
          <h4 class="font-dm text-sm font-bold text-ld-neutral uppercase tracking-wide mb-2">
            {{ t('modalsEconsentDisclosureConsentingTitle') }}
          </h4>
          <p class="font-dm text-sm text-ld-neutral leading-relaxed mb-3">
            {{ t('modalsEconsentDisclosureConsentingIntro') }}
          </p>
          <ol class="list-decimal pl-5 font-dm text-sm text-ld-neutral space-y-2">
            <li>{{ t('modalsEconsentDisclosureConsentingItem1') }}</li>
            <li>{{ t('modalsEconsentDisclosureConsentingItem2') }}</li>
            <li>{{ t('modalsEconsentDisclosureConsentingItem3') }}</li>
            <li>{{ t('modalsEconsentDisclosureConsentingItem4') }}</li>
          </ol>
        </section>

        <section id="econsent-disclosure-not-consenting">
          <h4 class="font-dm text-sm font-bold text-ld-neutral uppercase tracking-wide mb-2">
            {{ t('modalsEconsentDisclosureNotConsentingTitle') }}
          </h4>
          <p class="font-dm text-sm text-ld-neutral leading-relaxed">
            {{ t('modalsEconsentDisclosureNotConsentingTextPart1') }}
            <a
              id="econsent-disclosure-not-consenting-phone"
              [href]="supportPhoneTel"
              class="text-ld-primary font-semibold underline hover:text-ld-primary-600"
            >
              {{ supportPhoneDisplay }}
            </a>
            {{ t('modalsEconsentDisclosureNotConsentingTextPart2') }}
          </p>
        </section>
      </div>

      @if (showTcpaCheckbox()) {
        <div id="econsent-disclosure-tcpa-section" class="mt-6">
          <h4 class="font-dm text-sm font-bold text-ld-neutral uppercase tracking-wide mb-3">
            {{ t('consentTcpaConsentDialogTitle') }}
          </h4>
          <div
            id="econsent-disclosure-tcpa-checkbox"
            class="flex items-start gap-3 p-4 bg-ld-neutral-50 rounded-xl cursor-pointer select-none"
            role="checkbox"
            [attr.aria-checked]="tcpaChecked()"
            tabindex="0"
            (click)="toggleTcpa()"
            (keydown.space)="$event.preventDefault(); toggleTcpa()"
            (keydown.enter)="toggleTcpa()"
          >
            <mat-icon class="text-ld-primary shrink-0 mt-0.5">
              {{ tcpaChecked() ? 'check_box' : 'check_box_outline_blank' }}
            </mat-icon>
            <p class="font-dm text-sm text-ld-neutral leading-relaxed m-0">
              {{ tcpaDisclosureText() }}
            </p>
          </div>
        </div>
      }

      @if (showDeclineWarning()) {
        <div id="econsent-disclosure-decline-warning" class="p-4 bg-amber-50 border border-amber-200 rounded-xl mt-6">
          <div class="flex items-start gap-3">
            <mat-icon class="text-amber-600 shrink-0 mt-0.5">warning</mat-icon>
            <div>
              <h3 class="font-dm font-semibold text-amber-800 mb-1">
                {{ t('modalsEconsentDisclosureDeclineWarningTitle') }}
              </h3>
              <p class="font-dm text-sm text-amber-700 mb-3">
                {{ t('modalsEconsentDisclosureDeclineWarningText') }}
              </p>
              <button
                id="econsent-disclosure-confirm-decline-btn"
                type="button"
                class="px-4 py-2 text-sm font-dm font-medium text-amber-800 bg-amber-100 border border-amber-300 rounded-lg hover:bg-amber-200 transition-colors cursor-pointer"
                (click)="onDecline()"
              >
                {{ t('commonButtonsContinue') }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>

    <div modal-footer>
      <button id="econsent-disclosure-decline-btn" type="button" class="btn-outline-ld-purple" (click)="onDecline()">
        <mat-icon class="text-lg!">close</mat-icon>
        {{ t('modalsEconsentDisclosureDoNotConsentBtn') }}
      </button>
      <button id="econsent-disclosure-consent-btn" type="button" class="btn-primary-ld-purple" (click)="onConsent()">
        <mat-icon class="text-lg!">check</mat-icon>
        {{ t('modalsCommunicationConsentConsent') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
